import { render, staticRenderFns } from "./Aboutus.vue?vue&type=template&id=3392fb66&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"
import style0 from "./Aboutus.vue?vue&type=style&index=0&id=3392fb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392fb66",
  null
  
)

export default component.exports